import React from 'react';
import styled from 'styled-components';

interface DashboardCardProps {
  title: string;
  onClick?: () => void;
  content: React.ReactNode;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ title, onClick, content }) => (
  <Card onClick={onClick}>
    <ContentContainer>
      <Column>
        <CardTitle>{title}</CardTitle>
        {content}
      </Column>
    </ContentContainer>
  </Card>
);

export default DashboardCard;

// Styled Components
const Card = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px;
  border-radius: 6px;
`;

const CardTitle = styled.h3`
  font-family: 'Poppins', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
`;

const ContentContainer = styled.div`
  display: flex;
`;

const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;
